import { useState } from 'react';

interface ApiResponse {
  isLoading: boolean;
  createSession: () => Promise<string | undefined>;
  canCreate: boolean;
}

interface Props {
  isPremium: boolean;
  subscriberId: string;
  isLoggedIn: boolean;
  stripeCustomerId: string | null;
}

const useCreateStripePremiumSession = ({
  isPremium,
  stripeCustomerId,
  subscriberId,
  isLoggedIn,
}: Props): ApiResponse => {
  const shouldCreate = isPremium && !!stripeCustomerId && isLoggedIn;
  const [isLoading, setIsLoading] = useState(false);

  const handleCreate = async (): Promise<string | undefined> => {
    if (!shouldCreate) {
      throw new Error('Cannot create Stripe session');
    }

    const response = await fetch(`/stripe_premium_session?subscriber_id=${subscriberId}`);

    if (response.ok) {
      setIsLoading(true);
      const data = await response.json();
      setIsLoading(false);

      return data.sessionUrl;
    }
  };

  return {
    isLoading,
    canCreate: shouldCreate,
    createSession: handleCreate,
  };
};

export default useCreateStripePremiumSession;
